/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_Engine_VInputs */

const en_home_spec_engine_v = /** @type {(inputs: Home_Spec_Engine_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pure Rust, GPU rendered`)
};

/**
* | output |
* | --- |
* | "Pure Rust, GPU rendered" |
*
* @param {Home_Spec_Engine_VInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_engine_v = /** @type {((inputs?: Home_Spec_Engine_VInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_Engine_VInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_engine_v(inputs)
});
export { home_spec_engine_v as "home.spec.engine_v" }